enum KnownErrorCodes {
    NetworkError = -20,
}

export default KnownErrorCodes;
export { KnownErrorCodes };
